/* eslint-disable max-len */
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import {
  GridToolbarColumnsButton,
  GridToolbarDensitySelector
} from '@mui/x-data-grid';
import { useRef, useState } from 'react';

export function DropdownGridToolbarOption() {
  const anchorRef = useRef<HTMLButtonElement>(null);

  const [open, setOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState<boolean>(window.innerWidth > 880);

  const mobileMediaQuery = window.matchMedia('(max-width: 880px)');
  const desktopMediaQuery = window.matchMedia('(min-width: 881px)');

  mobileMediaQuery.onchange = (event) => {
    if (event.matches) setIsDesktop(false);
  };
  desktopMediaQuery.onchange = (event) => {
    if (event.matches) setIsDesktop(true);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Grid>
      {isDesktop ? (
        <Grid item>
          <GridToolbarColumnsButton />
          <GridToolbarDensitySelector />
        </Grid>
      ) : (
        <>
          <Button
            endIcon={open ? <ArrowDropUp /> : <ArrowDropDown />}
            onClick={handleToggle}
            ref={anchorRef}
            size="small"
          >
            {' '}
            Opciones
          </Button>
          <Popper
            anchorEl={anchorRef.current}
            open={open}
            style={{ zIndex: '99999' }}
            transition
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps}>
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <Grid flexDirection="column" container>
                      <Grid style={{ padding: '.5rem' }}>
                        <GridToolbarColumnsButton size="small" />
                      </Grid>
                      <Grid style={{ padding: '.5rem' }}>
                        <GridToolbarDensitySelector size="small" />
                      </Grid>
                    </Grid>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </>
      )}
    </Grid>
  );
}
